import { boolean, number, object } from "superstruct";

const VoteSchema = object({
    votes: number(),
    isCustomerVoted: boolean(),
});

export default VoteSchema;
